<template>
  <div
    class="grid w-full grid-cols-3 grid-rows-[repeat(5,minmax(33.334vw,auto))] font-avuText text-avu-black min-[900px]:grid-cols-[repeat(5,minmax(20vw,auto))] min-[900px]:grid-rows-[repeat(4,minmax(20vw,auto))]"
  >
    <div
      class="col-span-3 col-start-1 row-start-1 flex flex-col gap-6 py-20 pl-6 pr-6 sm:col-span-2 sm:row-span-2 sm:pl-[67px] min-[900px]:col-span-3 min-[900px]:py-[100px]"
    >
      <h2 class="text-xs/[33px] uppercase xl:text-base/[45px]">
        {{ aboutTitle }}
      </h2>

      <span
        class="text-[28px]/[36px] xl:text-[38px]/[48px]"
        v-html="aboutContent"
      />
    </div>

    <div
      class="col-start-2 row-start-2 bg-avu-blue sm:row-start-3 min-[900px]:col-start-4 min-[900px]:row-span-2 min-[900px]:row-start-1"
    />

    <div
      class="col-start-3 row-start-3 bg-avu-pink sm:row-start-4 min-[900px]:col-start-3 min-[900px]:row-start-3"
    />

    <div
      class="col-span-3 row-span-2 row-start-4 flex flex-col gap-[34px] px-[42px] py-[100px] sm:col-span-2 sm:row-span-2 min-[900px]:col-start-4 min-[900px]:row-start-3 xl:px-[93px]"
    >
      <h2 class="uppercase">{{ researchTitle }}</h2>

      <span class="text-base/[22px]" v-html="researchContent" />
    </div>
  </div>
</template>

<script setup>
  defineProps([
    "aboutTitle",
    "aboutContent",
    "researchTitle",
    "researchContent",
  ]);
</script>
